import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/work-orders/$workOrderId/")({
  component: NoTaskOpen,
})

function NoTaskOpen(): React.ReactElement {
  return <span />
}
